import { render, staticRenderFns } from "./VideoSeriesFilter.vue?vue&type=template&id=329b8496&scoped=true&"
import script from "./VideoSeriesFilter.vue?vue&type=script&lang=js&"
export * from "./VideoSeriesFilter.vue?vue&type=script&lang=js&"
import style0 from "./VideoSeriesFilter.vue?vue&type=style&index=0&id=329b8496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b8496",
  null
  
)

export default component.exports